import React from 'react';
import LoginModal from '../../login-register/modal/AppModalContainer';
import EstimateModal from '../../createestimate/EstimateModalContainer';

const App = () => (
  <div>
    <LoginModal />
    <EstimateModal />
  </div>
);

export default App;
